export default class Upload {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		if(!this.isset('image')) {
			this.item.image = false;
		}

		if(!this.isset('isUploading')) {
			this.item.isUploading = false;
		}

		if(!this.isset('url')) {
			this.item.url = '';
		}

		if(!this.isset('enabled')) {
			this.item.enabled = false;
		}

		if(!this.isset('align')) {
			this.item.align = 'center';
		}

        if(!this.isset('original_width')) {
            this.item.original_width = 0;
        }

        if(!this.isset('original_height')) {
            this.item.original_height = 0;
        }

		if(!this.isset('padding')) {
			this.item.padding = '10px 10px 10px 10px';
		}

		if(!this.isset('openInNewWindow')) {
			this.item.openInNewWindow = true;
		}
		
		if(!this.isset('id')) {
			this.item.id = false;
		}
	}
}


// WEBPACK FOOTER //
// ./helpers/upload.js